module.exports = {
  "country": "SE",
  "artist": "Cornelia Jakobs",
  "song": "Hold Me Closer",
  "year": "2022",
  "place": "4",
  "spotify": "697bFWgzBRm6bmnYWd8GyD"
};